import React from 'react';
import UIkit from 'uikit';
import Icons from 'uikit/dist/js/uikit-icons';
import Layout from '../common/Layout';
import { createGlobalStyle } from 'styled-components';
import QuicksandRegularWoffTwo from '../../fonts/Quicksand-Regular.woff2';
import QuicksandRegularWoff from '../../fonts/Quicksand-Regular.woff';
import QuicksandBoldWoffTwo from '../../fonts/Quicksand-Bold.woff2';
import QuicksandBoldWoff from '../../fonts/Quicksand-Bold.woff';
import RemedyDoubleWoffTwo from '../../fonts/remedydouble.woff2';
import RemedyDoubleWoff from '../../fonts/remedydouble.woff';

const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: 'Quicksand-Regular';
    font-style: normal;
    font-weight: normal;
    src:
      url('${QuicksandRegularWoffTwo}') format('woff2'),
      url('${QuicksandRegularWoff}') format('woff');
  }
  @font-face {
    font-family: 'Quicksand-Bold';
    font-style: normal;
    font-weight: normal;
    src:
      url('${QuicksandBoldWoffTwo}') format('woff2'),
      url('${QuicksandBoldWoff}') format('woff');
  }
  @font-face {
    font-family: 'remedydouble';
    font-style: normal;
    font-weight: normal;
    src:
      url('${RemedyDoubleWoffTwo}') format('woff2'),
      url('${RemedyDoubleWoff}') format('woff');
  }
  body bold {
    font-family: 'Quicksand-Bold', arial, sans-serif;
    font-weight: bold;
  }
  h1 span {
    font-family: remedydouble, "Times New Roman", Times, serif;
  }
`;
// loads the Icon plugin
UIkit.use(Icons);
/*
  This is the root component of your app. Here you define the overall layout
  and the container of the react router.
  You should adjust it according to the requirement of your app.
*/

const App = ({ children }) => (
  <React.Fragment>
    <GlobalStyle />
    <Layout className="home-app">{children}</Layout>
  </React.Fragment>
);
export default App;


// WEBPACK FOOTER //
// ./src/features/home/App.js